import ApiService from "@/core/services/ApiService";
import { WhiteLabel } from "@/core/services/api/interfaces/common/WhiteLabel";
import {
  getStorage,
  saveStorage,
  StorageData,
  StorageType,
} from "@/core/services/StorageService";
import { ThemeService } from "@/core/services/ThemeService";

export abstract class WhiteLabelService {
  protected static $key = "white_label";
  protected static $storageType: StorageType = "localStorage";

  public static async instantiate() {
    let whiteLabel = WhiteLabelService._getFromStorage();
    if (
      whiteLabel &&
      whiteLabel.updated_at &&
      new Date(whiteLabel.updated_at) <
        new Date(new Date().getTime() - 30 * 60000)
    ) {
      console.log("White label is outdated, refreshing...");
      whiteLabel = null;
    }
    if (!whiteLabel) {
      whiteLabel = await WhiteLabelService.loadWhiteLabel();
    }
    if (!whiteLabel) {
      return;
    }
    ThemeService.instantiate(whiteLabel);
  }

  protected static async loadWhiteLabel(): Promise<WhiteLabel & StorageData> {
    return ApiService.common.white_label
      .view()
      .then(ApiService.unwrapItemResponse<WhiteLabel & StorageData>)
      .then(WhiteLabelService._saveToStorage);
  }

  protected static _saveToStorage(
    whiteLabel: WhiteLabel & StorageData
  ): WhiteLabel & StorageData {
    saveStorage(
      whiteLabel,
      WhiteLabelService.$storageType,
      WhiteLabelService.$key
    );

    return whiteLabel;
  }

  protected static _getFromStorage(): null | (WhiteLabel & StorageData) {
    const result = getStorage(
      WhiteLabelService.$storageType,
      WhiteLabelService.$key
    );
    if ("{}" === JSON.stringify(result)) {
      return null;
    }

    return result as WhiteLabel & StorageData;
  }
}
